module.exports = __webpack_public_path__ + "img/vast.5f3e981c.png";